import React from 'react';
import axios from 'axios';
import { API_URL } from 'config.js';
import { store } from 'store.js';
import {
  caricamento,
  aggiornaContratti,
  aggiornaOpzioniTabella,
  aggiornaContrattoAttuale,
  mostraOrdiniFatture,
  caricamentoModale,
  aggiornaOrdini,
  aggiornaFatture,
  aggiornaTabellaSource,
} from 'features/99/contratti/contrattiSlice';

import { Button } from 'react-bootstrap';
import _ from 'lodash';

import { CONTRACT_TYPES } from 'constants.js';
import { getDate, getYear } from 'date-fns';

const API_CONTRATTI_URL = `${API_URL}/99/contratti/`;
const API_CONTRATTISUPP_URL = `${API_URL}/99/ordini_fatture/`;
const API_FILE_URL = `${API_URL}/generals/get_file/`;

export function filterContratti(contratti, filtro) {
  return (
    contratti?.filter((s) => {
      return filtro.formula(s.Valid_x0020_From, s.Valid_x0020_To);
    }) || []
  );
}

const colonna = (id, width, type, customHeader = false) => {
  const getName = (text, customSpace = 'x0020') => {
    return text
      .split('_')
      .map((x) => (x === customSpace ? ' ' : x))
      .join('');
  };

  return {
    dataField: id,
    text: customHeader || getName(id),
    sort: true,
    type: type === 'date' || type === 'scadenza' ? 'date' : 'string',
    headerStyle: { minWidth: width, textAlign: 'center' },
    classes: type === 'quantity' || type === 'price' || type === 'bottone_apri_contratto' ? 'text-center' : '',
    sortCaret: (order, c) => {
      switch (order) {
        case 'asc':
          return ' ᗑ';
        case 'desc':
          return ' ᗐ';
        default:
          return null;
      }
    },
    formatter: (cell, row) => {
      if (type === 'price') {
        return `€ ${cell?.toFixed(2)}`;
      }

      if (type === 'quantity') {
        const cellfor = cell
          ?.toFixed(2)
          .toString()
          .split(/(?=(?:\d{3})+(?:\.|$))/g)
          .join(',');

        return `Kg. ${cellfor}`;
      }

      if (type === 'scadenza') {
        // 27/08/2006
        // giorno mese anno => anno mese giorno
        // convertire data di cist in data computer
        const dataFormattata = cell?.split('/')?.reverse()?.join('-'); // 27/08/2006 -> 2006-08-27
        const dataCella = new Date(dataFormattata);
        const dataDiOggi = new Date();
        // sottraggo la data della cella dalla data di oggi e controllo che questa differenza sia meno di 3 mesi
        const differenzaDate = dataCella - dataDiOggi;

        const novantaGiorni = 24 * 60 * 60 * 1000 * 90;
        if (differenzaDate < novantaGiorni) {
          return (
            <div className="badge bg-danger">
              <p className="text font-weight-bold m-0 h4">{cell}</p>
            </div>
          );
        }

        return cell;
      }

      if (type === 'bottone_apri_dettagli') {
        return (
          <>
            <Button
              variant="primary"
              className="mb-2 w-100"
              onClick={() => {
                store.dispatch(aggiornaContrattoAttuale(cell));
                store.dispatch(mostraOrdiniFatture('MOVIMENTI'));
              }}
            >
              Delivery / invoices
            </Button>
            <Button
              variant="primary"
              className="w-100"
              onClick={() => {
                store.dispatch(aggiornaContrattoAttuale(cell));
                store.dispatch(mostraOrdiniFatture('ORDINI'));
              }}
            >
              View Orders
            </Button>
          </>
        );
      }

      return cell;
    },
  };
};

export function getColonne(dati, valoreSpazio = 'x0020') {
  return [
    { id: 'Contract' },
    { id: 'Valid_x0020_From', tipo: 'date', width: '100' },
    { id: 'Valid_x0020_To', tipo: 'scadenza', width: '100' },
    { id: 'Item_x0020_description', width: 200 },
    { id: 'Quantity', tipo: 'quantity' },
    { id: 'Price', tipo: 'price', width: 70 },
    { id: 'Ordered_x0020_Quantity', tipo: 'quantity' },
    { id: 'Credit_x0020_Note_x0020_Quantity', tipo: 'quantity', width: 100 },
    { id: 'Shipped_x0020_Quantity', tipo: 'quantity' },
    { id: 'Balance_x0020_Quantity', tipo: 'quantity' },
    { id: 'Your_x0020_Item_x0020_Number' },
    { id: 'Id', titolo: 'Documents', tipo: 'bottone_apri_dettagli' },
  ].map((o) => colonna(o.id, o.width ?? 120, o.tipo ?? '', o.titolo ?? false));
}

// const d1 = new Date(2022, 6, 4);
// const current = new Date();
// if (d1.getFullYear() === current.getFullYear() && d1.getMonth() === current.getMonth() + 3 && d1.getDate() === current.getDate()) {
// alert('funzia');
// }

const getCreds = () => {
  const {
    auth: {
      currentUser: { pin, utente },
    },
  } = store.getState();

  return [utente, pin];
};

export const richiediDati = async () => {
  store.dispatch(caricamento(true));

  const [utente, pin] = getCreds();

  const res = await axios.post(API_CONTRATTI_URL, { utente, pin });
  const {
    data: {
      successo,
      errore,
      dati: { contratti },
    },
  } = res;
  if (!successo) {
    store.dispatch(caricamento(false));
    return alert(errore);
  }

  if (successo && contratti.length) {
    store.dispatch(aggiornaContratti(contratti));
    store.dispatch(aggiornaTabellaSource(filterContratti(contratti, CONTRACT_TYPES.TOTALE)));
    store.dispatch(aggiornaOpzioniTabella({ data: contratti, columns: getColonne(contratti) }));
    store.dispatch(caricamento(false));
  }

  store.dispatch(caricamento(false));
  return true;
};

export const contrattiSupp = async (idContratto) => {
  store.dispatch(caricamentoModale(true));

  const [utente, pin] = getCreds();

  const res = await axios.post(API_CONTRATTISUPP_URL, { utente, pin, idContratto });

  const {
    data: {
      successo,
      errore,
      dati: { ordiniFatture },
    },
  } = res;

  if (!successo) {
    store.dispatch(caricamentoModale(false));
    return alert(errore);
  }

  if (successo && ordiniFatture.length) {
    const ordiniFattureGroup = _.groupBy(ordiniFatture, (o) => {
      return o.Tipo;
    });

    store.dispatch(aggiornaOrdini(ordiniFattureGroup.ORDINI || []));
    store.dispatch(aggiornaFatture(ordiniFattureGroup.MOVIMENTI || []));
    store.dispatch(caricamento(false));
  }

  store.dispatch(caricamentoModale(false));
  return true;
};

export const getDocName = (documento, anno) => {
  const codice = documento.substring(0, 2); // es. BC
  const serie = `0${documento.charAt(2)}`; // es. 01
  const numero = `000000${documento.split('/')[1]}`.slice(-6); // es. 002699

  return `${anno}-${codice}-${serie}-${numero}`;
};

const b64toBlob = (b64Data, contentType = 'application/pdf', sliceSize = 512) => {
  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i += 1) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, { type: contentType });
  return blob;
};

export const getFile = async (idContratto, documento, anno, onBeforeRequest, onAfterRequest) => {
  onBeforeRequest();

  const [utente, pin] = getCreds();
  const res = await axios.post(API_FILE_URL, { utente, pin, idContratto, documento: getDocName(documento, anno) });

  const { successo } = res.data;

  if (!successo) {
    const { errore } = res.data;
    alert(errore);
    onAfterRequest();
    return;
  }

  const { file } = res.data; // YEY abbiamo il nostro file base64
  const fileBlob = b64toBlob(file);
  const fileUrl = URL.createObjectURL(fileBlob);

  window.open(fileUrl, '_blank');

  onAfterRequest();
};

// export function filterContratti(filtro){
//   const {
//     contratti99: {

//     }
//   }
// }
